import { FormStatusEnum, FormType } from "src/app/common/enumerations/enumerations";
import { Resource } from "../../../components/catalogs/beamline-catalog/resource/resources";
import { ChecklistExecStatus } from "src/app/components/checklists/checklists";

export class Restriction {
  public id?: number;
  public resourceID?: number;
  public locationID?: number;
  public restrictionLanguage?: string;
  public alternateRestrictionLanguage?: string;
  public scf?: boolean;
  public rsswa?: boolean;
  public ebf?: boolean;
  public ppstb?: boolean;
  public rsf?: boolean;
  public resource?: Resource;
  public location?: Resource;
  public resourceName?: string;
  public locationName?: string;
  public isModified?: boolean;
  public isDeleted?: boolean;
  public isAdded?: boolean;
}

export class SaveRestriction {
  public resourceID?: number;
  public locationID?: number;
  public restrictionLanguage?: string;
  public alternateRestrictionLanguage?: string;
}

export interface ProcessRestrictionResult {
  affectedForms: AffectedForm[];
  radSurveyRequired: RadSurveyRequired;
  radSurveyAffectedForms: AffectedForm[];
  // Open forms that reference the location without a matching restriction (caution only)
  locationAffectedForms?: AffectedForm[];
}

export interface AffectedForm {
  formType: FormType;
  formID: number;
  serialNo: string;
  formStatus: FormStatusEnum;
  radSurveyChecklists: RadSurveyChecklist[];
}

export interface RadSurveyChecklist {
  id: number;
  serialNo: string;
  statusID: number;
  checklistStatus: ChecklistExecStatus;
}

export enum RadSurveyRequired {
  Unknown = 0,
  Required = 1,
  NotRequired = 2
}